import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const transform = 'matrix(1,0,0,1,0,-4)';

const d =
  'M7.5,17.333L7.5,13.167C7.5,12.247 8.247,11.5 9.167,11.5L13.333,11.5L7.5,17.333ZM13.333,4L1.667,4C0.747,4 0,4.748 0,5.667L0,17.333C0,18.253 0.747,19 1.667,19L7.5,19C8.183,19 9.029,18.649 9.512,18.167L14.167,13.512C14.65,13.028 15,12.182 15,11.5L15,5.667C15,4.748 14.253,4 13.333,4Z';

const Download: React.FC<IconProps> = ({
  className = '',
  clipRule = 'evenodd',
  fill = colors.blueGrey,
  fillRule = 'evenodd',
  strokeLinejoin = 'round',
  strokeMiterlimit = '2',
  viewBox = '0 0 15 15',
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      clipRule={clipRule}
      fill={fill}
      fillRule={fillRule}
      strokeLinejoin={strokeLinejoin}
      strokeMiterlimit={strokeMiterlimit}
      viewBox={viewBox}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.G transform={transform}>
        <Elements.Path d={d} />
      </Elements.G>
    </Elements.Svg>
  );
};

export default Download;
